import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  currentTheme: any = 'dark';

  constructor() {
    this.toggleTheme(); // Load the theme from localStorage on app start
  }

  // Toggle the theme
  toggleTheme() {
    // clear html tag dark
    if (document.documentElement.classList.contains("dark")) {
      document.documentElement.classList.remove("dark");
    }
    this.currentTheme = localStorage.getItem("theme")
      ? localStorage.getItem("theme")
      : this.currentTheme;
    if (this.currentTheme === "dark") {
      this.setDarkMode();
    } else {
      this.setLightMode();
    }
  }
  getCurrentTheme() {
    return this.currentTheme;
  }

  // Apply dark theme
  setDarkMode() {
    document.body.classList.add("dark");
    localStorage.setItem("theme", "dark");
  }

  // Apply light theme
  setLightMode() {
    document.body.classList.remove("dark");
    localStorage.setItem("theme", "light");
  }

  switchTheme(themeToSwitch: any) {
    localStorage.setItem("theme", themeToSwitch);
    this.toggleTheme();
  }
}
